import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from "@mui/material";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { activateAccount, deactivateAccount, getAllUsers } from "../../services/users/userService";
import { setListAllUsers } from "../../redux/slice/usersSlice";
import { useDispatch } from "react-redux";

const DeactivateAccountModal = ({ open, setOpen, userData, setLoading }) => {
    const dispatch = useDispatch();
    const handleChangeStatus = async () => {
        try {
            setLoading(true);
            if (userData?.status === "canceled") await activateAccount(userData?._id)

            if (userData?.status === "active") await   deactivateAccount(userData?._id)

            const responseListUsers = await getAllUsers();
            dispatch(setListAllUsers({ listAllUsers: responseListUsers }));
            setOpen(false)
            toast.success(`Se ${userData?.status === "canceled" ? "activo" : "desactivo"} correctamente.`)
            setLoading(false);

        } catch (error) {
            const { message } = handleError(error);
            toast.error(`Algo salió mal.  \n ${message}`);
            setLoading(false);
        }
    }


    return (
        <Dialog open={open} >
            {
                userData?.status === "active" ?
                    <DialogTitle>Desactivar cuenta</DialogTitle> :
                    <DialogTitle>Activar cuenta</DialogTitle>
            }

            <DialogContent >
                {
                    userData?.status === "active" ?

                        <Typography>
                            ¿Estás seguro de que deseas desactivar la cuenta cuenta con correo {userData?.email}?. El usuario perdera el acceso.
                        </Typography> :
                        <Typography>
                            ¿Estás seguro de que deseas activar la cuenta con correo {userData?.email}?. El usuario recuperará el acceso a la plataforma.
                        </Typography>
                }
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpen(false)} variant="outlined" color="white">
                    Cancelar
                </Button>

                <Button onClick={handleChangeStatus} variant="contained" color={userData?.status === "active" ? "error" : "success"}>
                    {userData?.status === "active" ? "Desactivar cuenta" : "Activar cuenta"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeactivateAccountModal;
